import { Material } from "../models/material";
import { Recipe, RecipeCategory } from "../models/recipe";
import { DefaultUseMethod } from "../models/recipeusemethod";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export function createOrUpdateRecipe(recipe: Recipe): Request {
  let tipCount = recipe.tip;
  let useMethod = recipe.useMethod;
  if (
    !recipe.id &&
    (recipe.category === RecipeCategory.Tcm ||
      recipe.category === RecipeCategory.TcmGranules)
  ) {
    tipCount = 7;
    useMethod = DefaultUseMethod.join(",");
  }
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/save`,
    method: "POST",
    body: { ...recipe, tip: tipCount, useMethod },
  };
}

export function getRecipeList(treatmentId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/list`,
    method: "GET",
    params: {
      treatmentId,
    },
  };
}

export function getRecipeDetail(recipeId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/list`,
    method: "GET",
    params: {
      id: recipeId,
    },
  };
}

export function removeRecipe(recipeId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/remove`,
    method: "POST",
    params: {
      recipeId,
    },
  };
}

export interface SaveRecipeMaterialsParams {
  treatmentId: string;
  recipeId: string;
  validateInventory: boolean;
  materials: Material[];
}

export function saveRecipeMaterials(
  params: SaveRecipeMaterialsParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeitem/batchsave`,
    method: "POST",
    params: {
      validateInventory: params.validateInventory,
    },
    body: params.materials.map((m) => ({
      ...m,
      treatmentId: params.treatmentId,
      recipeId: params.recipeId,
    })),
  };
}

export function getMaterials(recipeId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeitem/list`,
    method: "GET",
    params: {
      recipeId,
    },
  };
}

export function removeMaterials(ids: string[]): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeitem/remove`,
    method: "POST",
    params: {
      recipeItemIds: ids.join(","),
    },
  };
}

export function updateSortAndGroupNumber(materials: Material[]): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipeitem/group`,
    method: "POST",
    body: materials.map((m) => ({
      groupNumber: m.groupNumber,
      sort: m.sort,
      id: m.id,
    })),
  };
}

export function finishTreatment(treatmentId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/finish`,
    method: "POST",
    params: {
      treatmentId,
    },
  };
}

export interface CopyRecipeParams {
  copyWithAmount: boolean;
  destRecipeId: string;
  srcRecipeId: string;
}

export function copyRecipe(params: CopyRecipeParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/recipe/copy`,
    method: "POST",
    body: params,
  };
}

export interface CreateRetailRecipeParams {
  treatmentId?: string;
  category: RecipeCategory;
  tip?: number;
  useMethod?: string;
}

export function createRetailRecipe(params: CreateRetailRecipeParams): Request {
  let tipCount = 1;
  let useMethod = "";
  if (
    params.category === RecipeCategory.Tcm ||
    params.category === RecipeCategory.TcmGranules
  ) {
    tipCount = 7;
    useMethod = DefaultUseMethod.join(",");
  }
  return {
    url: `${API_PREFIX}/blade-outpatient/quicksales/saveRecipe`,
    method: "POST",
    body: { ...params, tip: tipCount, useMethod },
  };
}
